export const ADD_ASPIRATIONS_QUESTION = "ADD_ASPIRATIONS_QUESTION"
export const EDIT_ASPIRATIONS_QUESTION = "EDIT_ASPIRATIONS_QUESTION"
export const LIST_ASPIRATIONS_QUESTION = "LIST_ASPIRATIONS_QUESTION"
export const VIEW_ASPIRATIONS_QUESTION = "VIEW_ASPIRATIONS_QUESTION"
export const DELETE_ASPIRATIONS_QUESTION = "DELETE_ASPIRATIONS_QUESTION"

// Text
export const ADD_ASPIRATIONS_TEXT = "ADD_ASPIRATIONS_TEXT"
export const EDIT_ASPIRATIONS_TEXT = "EDIT_ASPIRATIONS_TEXT"
export const LIST_ASPIRATIONS_TEXT = "LIST_ASPIRATIONS_TEXT"
export const VIEW_ASPIRATIONS_TEXT = "VIEW_ASPIRATIONS_TEXT"
export const DELETE_ASPIRATIONS_TEXT = "DELETE_ASPIRATIONS_TEXT"

export const ASPIRATIONS_SUCCESS = "ASPIRATIONS_SUCCESS"
export const ASPIRATIONS_ERROR = "ASPIRATIONS_ERROR"

